/*
 *   File : create-rebalance.js
 *   Author : https://evoqins.com
 *   Description : Rebalance order creation modal
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import { memo, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// Component
import { PrimaryButton, SecondaryButton } from "../Buttons";
import { OTPInput } from "../Form-Elements";
import { _getOTP } from "../../Helper";
import { APIService } from "../../Service";

// Asset 
import Success from "../../Assets/Images/success.webp";
import CloseBtn from "../../Assets/Images/close-btn-white.svg";


function CreateRebalanceModal(props) {

    const navigate = useNavigate();

    const otpInputRef = useRef(null);
    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA) || {};

    const [otpVerified, setOtpVerified] = useState(false);
    const [otpValue, setOtpValue] = useState("");
    const [otpError, setOtpError] = useState("");
    const [focusedInput, setFocusedInput] = useState(0);
    const [timer, setTimer] = useState(30);
    const [loading, setLoading] = useState(false);
    const [disableResendOTP, setDisableResendOTP] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setFocusedInput(2);
        }, 500);
    }, [])


    // OTP timer
    useEffect(() => {
        if (timer > 0) {
            const countdown = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(countdown);
        }
    }, [timer]);

    const _handleCloseModal = () => {
        props.onCloseModal();
    };

    const _handleChangeOTP = (value) => {
        setOtpValue(value);
        setOtpError("");
    };

    const _handleResendOTP = () => {
        setDisableResendOTP(true);
        const param = { type: "Rebalance" };
        _getOTP(param).then((status) => {
            if (status.status_code === 200) {
                setOtpValue("");
                setOtpError("");
                setTimer(30);
                setFocusedInput(2);
                toast.dismiss();
                const message_medium = USER_DATA.phone.country_code == "+91" ? " mobile" : " email";
                toast.success(`OTP sent successfully to registered ${message_medium}`, {
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error("Something went wrong please try later", { className: "e-toast" });
            }
            setDisableResendOTP(false);
        });
    };

    const _handleVerifyOtp = () => {

        if (otpValue.length === 0) {
            setOtpError("Please enter the OTP");
            return;
        }
        if (otpValue.length !== 4) {
            setOtpError("Please enter the full OTP");
            return;
        }

        // API call
        setLoading(true);
        _createRebalance();

    };

    //==================================== //
    //=========== API CAll ============== //

    // Create Rebalance
    const _createRebalance = () => {

        let is_post = true;
        let api_version = 2;
        let url = 'rebalance/consent';
        let data = {
            "skip": false,
            "otp": otpValue
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setOtpVerified(true);
            } else {
                toast.dismiss();
                toast.error(response.message, { className: "e-toast" });
            }
        }).finally(() => {
            setLoading(false);
        });
    };


    return (
        <div className="modal fade p-0 m-0"
            id="status-modal"
            tabIndex="-1"
            aria-labelledby="StatusModal"
            data-bs-backdrop="static"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered min-h90vh">
                {
                    otpVerified === false ? (
                        <div className="modal-content e-bg-lotion e-border-radius-24 e-modal-box-shadow">
                            <div className="modal-header justify-content-between e-gap-0-16 pt-4 pb-3 px-4 border-0">
                                <h6 className="mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px">
                                    OTP verification
                                </h6>
                                <img src={CloseBtn}
                                    id='mf-invest-modal-close'
                                    width={32}
                                    height={32}
                                    draggable={false}
                                    className='cursor-pointer'
                                    data-bs-dismiss="modal"
                                    aria-label="close"
                                    alt='close btn'
                                    onClick={props.onCloseModal} />
                            </div>
                            <div className="modal-body pb-4 px-4 pt-0">
                                <div className="p-3 e-border-radius-16 e-bg-cultured">
                                    {USER_DATA?.phone?.country_code == "+91" ? (
                                        <p className="mb-0 e-text-onyx e-font-16 e-alt-font-poppins e-font-weight-400 line-height-28px">
                                            An OTP has been sent to your registered mobile number.
                                            <span className="ms-1 e-text-egyptian-blue e-font-weight-500">
                                                {USER_DATA?.phone?.country_code} {USER_DATA?.phone?.number}
                                            </span>
                                        </p>
                                    ) : (
                                        <p className="mb-0 e-text-onyx e-font-16 e-alt-font-poppins e-font-weight-400 line-height-28px">
                                            An OTP has been sent to your registered email.
                                            <span className="ms-1 e-text-egyptian-blue e-font-weight-500">
                                                {USER_DATA?.email}
                                            </span>
                                        </p>
                                    )}
                                    <div className="pt-3">
                                        <label className="e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px">
                                            Enter your OTP*
                                        </label>
                                        <OTPInput ref={otpInputRef}
                                            id="status-modal-otp"
                                            autoFocus={true}
                                            value={otpValue}
                                            spellCheck="false"
                                            focused_input={focusedInput}
                                            error={otpError}
                                            onFocus={() => setFocusedInput(2)}
                                            onBlur={() => setFocusedInput(0)}
                                            onChange={_handleChangeOTP} />

                                        <div className="e-inline-flex mt-2">
                                            <button
                                                className={`${timer === 0 ? "text-decoration-hover-underline" : "e-disable"} border-0 e-bg-transparent e-text-egyptian-blue e-font-12 e-alt-font-poppins e-font-weight-500 line-height-26px ps-0`}
                                                disabled={disableResendOTP}
                                                type="button"
                                                onClick={_handleResendOTP}>
                                                Re-send OTP
                                            </button>
                                            {timer !== 0 && (
                                                <p className="mb-0 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-600 line-height-26px">
                                                    in {timer} {timer == 1 ? "second" : "seconds"}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <p className="mb-0 pt-3 e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-18px">
                                        *In accordance with regulatory, 2FA verification is required in order to create an order.
                                    </p>
                                </div>
                                <div className="d-flex gap-3 mt-4">
                                    <SecondaryButton name="Cancel"
                                        dismiss={"modal"}
                                        borderRadius="e-border-radius-10"
                                        className="w-100 padding-12px-tb e-border-radius-24 e-bg-lotion e-font-16 e-text-charleston-green e-border-bright-gray"
                                        onPress={_handleCloseModal} />
                                    <PrimaryButton name="Submit"
                                        loading={loading}
                                        disabled={loading}
                                        className="e-border-radius-24 w-100 padding-12px-top e-font-16  padding-12px-bottom e-primary-button-hover transition"
                                        onPress={_handleVerifyOtp} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="modal-content e-bg-lotion e-border-radius-24 e-modal-box-shadow">
                            <div className="modal-body p-4 e-border-radius-24 modal-gradient-bg">
                                <div className=" d-flex flex-column align-items-center ">
                                    <img src={CloseBtn}
                                        draggable={false}
                                        className="cursor-pointer float-end align-self-end"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        alt="close"
                                        width={32}
                                        height={32}
                                        onClick={_handleCloseModal}
                                    />

                                    <img className="img-fluid col-5 mt-4 pt-3"
                                        draggable={false}
                                        src={Success}
                                        width={"100%"}
                                        height={"100%"}
                                        fetchPriority="high"
                                        alt="payment status image" />
                                    <p className="e-font-14-res text-center e-text-charleston-green e-alt-font-poppins e-font-18 e-font-weight-600 mt-4 mb-2">
                                        Portfolio Rebalance
                                    </p>
                                    <p className="e-font-12-res line-height-20px-res col-sm-11 mx-auto text-center e-text-dark-liver e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px text-center mx-auto mb-4">
                                        Your rebalance consent has been recorded. Switch orders are being processed and will appear in your order history shortly. You will also receive an email notification once completed.
                                    </p>

                                    <PrimaryButton name="Home"
                                        dismiss="modal"
                                        className="e-border-radius-24 padding-12px-tb w-50 mx-auto"
                                        onPress={() => navigate("/")} />
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        </div>
    );
}

export default memo(CreateRebalanceModal);
